// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b7fd70c","453":"e4efdc89","667":"7be6b88d"}[chunkId] + ".chunk.js";
};